import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Collapse, {Panel} from 'rc-collapse';

import {getTransactions} from '../../../../redux/actions/contractAction';
import Loader from './Loader/Loader';

import './contractTransactions.scss';
import {transactionDate} from '../../../../helpers/common';

const ContractTransactions = ({dealId}) => {
  const {transactions, isTransactionsLoading} = useSelector(({contract}) => contract);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = {dealId, sortBy: "create_date", size: 200}
    dispatch(getTransactions(data));
  }, [dealId, dispatch]);

  const groupTransactions = (transactions) => {
    let groups = [];
    let previousOperationId = undefined;
    let lastGroup = undefined;
    for (let i = 0; i < transactions.length; i++) {
      let tr = transactions[i];
      if (tr.operationId !== previousOperationId) {
        lastGroup = {
          sum: 0,
          reverted: true,
          date: transactionDate(tr),
          transactions: [],
        };
        groups.push(lastGroup);
        previousOperationId = tr.operationId;
      }
      lastGroup.transactions.push(tr);
      if (!tr.reverted) {
        lastGroup.reverted = false;
      }

      if (tr.section === 'CLOSURE_RECALCULATION') {
        lastGroup.sum -= tr.amount;
      } else {
        lastGroup.sum += tr.amount;
      }
    }
    return groups;
  };

  return isTransactionsLoading ? (
    <Loader/>
  ) : (
    <fieldset className="m-t-spacer-2">
      <div className="content-section-title m-t-spacer-2">
        <h3>Транзакции</h3>
      </div>
      {transactions?.transactions &&
      transactions.transactions.length > 0 &&
      groupTransactions(transactions.transactions).map((group, index) => {
        return (
          <Collapse key={'gr' + index} className="">
            <Panel
              header={group.date}
              extra={
                <span>
                    {group.sum.toFixed(2)} <abbr>руб.</abbr>
                  </span>
              }
              headerClass="block-datacollapse-header"
              className={
                group.reverted
                  ? 'block-datacollapse-container reverted'
                  : 'block-datacollapse-container'
              }>
              {group.transactions.map((tr, index) => {
                return (
                  <div
                    key={'tr' + index}
                    className={
                      tr.reverted
                        ? 'block-datacollapse-rowitem reverted'
                        : 'block-datacollapse-rowitem'
                    }>
                    <div className="block-datacollapse-rowitem-description">
                      <p>{tr.description}</p>
                    </div>
                    <div className="block-datacollapse-rowitem-value">
                      <p>
                        {tr.amount.toFixed(2)} <abbr>руб.</abbr>
                      </p>
                    </div>
                  </div>
                );
              })}

              <div
                className={
                  group.reverted
                    ? 'block-datacollapse-rowitem accent reverted'
                    : 'block-datacollapse-rowitem accent'
                }>
                <div className="block-datacollapse-rowitem-description">
                  <p>Общая сумма</p>
                </div>
                <div className="block-datacollapse-rowitem-value">
                  <p>
                    {group.sum.toFixed(2)} <abbr>руб.</abbr>
                  </p>
                </div>
              </div>
            </Panel>
          </Collapse>
        );
      })}
    </fieldset>
  );
};

export default ContractTransactions;
